import React, { Component } from 'react';
import { Upload, Form, Icon, Button } from 'antd';
import { Alert } from '../../../components';

class UploadCSV extends Component {
    state = {
        fileList: [],
    };

    validationRules = () => {
        let validation = [];
        if (this.props.validationrules) {
            this.props.validationrules.forEach((item, index) => {
                if (typeof (item) === "string") {
                    let valType = item.split(".");
                    switch (valType[0]) {
                        case "required":
                            validation.push({ required: true, message: `${this.props.labeltext} is Required` })
                            break;
                        default:
                    }
                }
                else if (typeof (item) === "function") {
                    validation.push({
                        validator: item
                    })
                }
            })
        }

        return validation;
    }

    normFile = e => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    handleChange = (info) => {
        let accept = (this.props.accept) ? this.props.accept.split(",").map(t => t.trim().toLowerCase()) : ['.csv', '.xlsx'];

        let fileList = info.fileList.filter(f => {
            let ext = f.name.substring(f.name.lastIndexOf(".")).toLowerCase();
            return accept.includes(ext);
        });

        // Batasi 1 file terakhir
        fileList = fileList.slice(-1);

        this.setState({ fileList });
    };

    clearFiles = () => {
        this.setState({ fileList: [] });
    };

    render() {
        const upload = {
            onRemove: file => {
                this.setState(state => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList,
                    };
                });
            },
            beforeUpload: file => {
                if (this.props.moreValidation) {
                    // ambil ekstensi yang diperbolehkan, misalnya ".csv, .xlsx"
                    let accept = (this.props.accept) ? this.props.accept.split(",").map(t => t.trim().toLowerCase()) : ['.csv', '.xlsx'];

                    // ambil ekstensi dari file upload, lalu lowercase
                    let ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();

                    if (!accept.includes(ext)) {
                        Alert.error(`Only ${accept.join(", ")} files are allowed! This file will be removed.`);
                        return true; // blokir
                    } else {
                        this.setState(state => ({ fileList: [...state.fileList, file] }));
                        return false; // jangan upload ke server, cuma masuk ke state
                    }
                } else {
                    this.setState(state => ({
                        fileList: [...state.fileList, file],
                    }));
                    return false;
                }
            },
            onChange: this.handleChange,
            headers: {
                authorization: 'authorization-text',
            },
        };

        const { fileList } = this.state;
        const { getFieldDecorator } = this.props.form;
        let labelPosition = (this.props.labelCol && this.props.wrapperCol) ? {
            labelCol: this.props.labelCol,
            wrapperCol: this.props.wrapperCol
        } : null;
        let getValueFromEvent = this.props.getValueFromEvent ? this.props.getValueFromEvent : this.normFile;

        return (
            <Form.Item label={this.props.labeltext} className={this.props.className} {...labelPosition}>
                {getFieldDecorator(this.props.datafield, {
                    getValueFromEvent: this.props.getValueFromEvent || ((e) => (Array.isArray(e) ? e : e?.fileList)),
                    rules: this.validationRules?.(),
                })(
                    <Upload {...upload} {...this.props} action="/upload.do" listType="text" accept={this.props.accept ? this.props.accept : '.csv, .xlsx'} fileList={fileList} showUploadList={{ showRemoveIcon: false }}>
                        <Button disabled={this.props.disabled}> <Icon type="upload" /> Choose File </Button>
                    </Upload>,
                )}
            </Form.Item>
        )
    }

}

export default UploadCSV;
